/* global localStorage */

import * as MutationTypes from './mutation-types'
import { mapGetters, mapState, mapSetters } from 'vuex'

const getDefaultState = () => {
    return {
        address: {
          city: '',
          company_name: '',
          firstname: '',
          lastname: '',
          number: '',
          phone: '',
          street: '',
          zip: '',
        },
        logo: '',
        name: '',
        token: '',
        
    }
  }

const state = getDefaultState()

const getters = {
  currentDealer (state) {
    return state;
},
  getDealer (state) {
        return state;
    }
}

const actions = {
    saveDealer({ commit }) {
      commit('setDealer');
    },
    resetDealer ({ commit }) {
      commit('resetState')
    },
}

const mutations = {
    setDealer (state, item){
        state.dealer = item;
    },
    resetState (state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, getDefaultState())
    }
}

export default {
  state,
  actions,
  mutations,
  getters
}


